export function serverData(valueIdentifier) {
    if (window.isServer) {
        return window.serverData[valueIdentifier];
    }
    // Client (browser) code - try to find data in HTML
    const el = document.getElementById(`serverData-${valueIdentifier}`);
    if (el?.textContent) {
        try {
            const data = JSON.parse(el.textContent);
            el.remove();
            return data;
        } catch (e) {
            console.error("Error parsing serverData for", valueIdentifier, e);
        }
    }
    // No data from server => async call to server needed for fetching the data
    return undefined;
}